import { call, register, remove } from "../../funcStore";
import { useEffect, useRef, useState } from "react";
import { logAction } from "../../api/logApi";
import { rejectAttribute, removeApprovedAttribute } from "../../api/commonApi";
import TagList from "./TagList";
import { recordSearchFilters, recordVtuberView } from "../../utils/userPreference";

const styles = {
  card: {
    gap: "12px",
    padding: "12px",
    background: "#fff",
    border: "none",
    borderRadius: "8px",
    textAlign: "left",
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  iconWrapper: {
    width: "100%",
    display: "flex",
    border: "none",
    padding: 10,
    marginBottom: 10,
  },
  cardIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    objectFit: "cover",
    marginRight: 5,
  },
  cardName: {
    margin: "0 0 4px",
    fontSize: "1rem",
  },
  cardSubscribers: {
    margin: "0 0 6px",
    fontSize: "0.8rem",
    color: "#666",
  },
};

function VTuberCard({ vtuberId }) {
  // state
  const [vtuber, setVtuber] = useState(null);

  const funcKeyRef = useRef(`vtuberCard.${vtuberId}`);
  const funcKey = funcKeyRef.current;

  // effect
  useEffect(() => {
    const load = async () => {
      const result = await call("searchPage.getVtuberById", vtuberId);
      const sortResult = sortAttribute(result);

      register(`${funcKey}.getAttributes`, () => sortResult.attributes);

      register(`${funcKey}.tagClick`, (tag) => {
        call("app.searchByTag", tag);
      });

      register(`${funcKey}.removeAttribute`, (tag, approved) => {
        logAction("attribute_admin_remove", { vtuberId, tag, approved });

        sortResult.attributes = sortResult.attributes.filter(
          (attribute) => attribute.value !== tag,
        );

        call(`${funcKey}.tagList.refresh`);

        const removeFromServer = approved
          ? removeApprovedAttribute(vtuberId, tag)
          : rejectAttribute(vtuberId, tag);

        removeFromServer.catch((error) => {
          console.error(error);
        });
      });

      setVtuber(sortResult);
    };
    load();

    return () => {
      remove(`${funcKey}.getAttributes`);
      remove(`${funcKey}.tagClick`);
      remove(`${funcKey}.removeAttribute`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vtuberId]);

  if (!vtuber) {
    return null;
  }

  const handleClick = () => {
    recordVtuberView(vtuberId);
    logAction("navigate_detail", { vtuberId: vtuberId });
    call("app.navigateToDetail", vtuberId);
  };

  function sortAttribute(result) {
    const attributes = [
      ...result.attributes.map((a)=>({value:a,approved:true})),
      ...result.candidate_attributes.map((a)=>({value:a,approved:false}))];
    const sortedAtrributes = attributes.sort((a, b) => {
      if (a.approved && !b.approved) {
        return -1;
      }
      return 1;
    });
    const value = { ...result, attributes: sortedAtrributes };
    return value;
  }

  return (
    <div style={styles.card}>
      <button type="button" onClick={handleClick} style={styles.iconWrapper}>
        <img style={styles.cardIcon} src={vtuber.icon_url} alt={vtuber.name} />
        <div>
          <h3 style={styles.cardName}>{vtuber.name}</h3>
          <p style={styles.cardSubscribers}>
            登録者数: {vtuber.subscriber_count?.toLocaleString() ?? 0}人
          </p>
        </div>
      </button>

      {!(vtuber.is_visiable && !vtuber.is_arrow) && (
        <TagList parentKey={funcKey} />
      )}
    </div>
  );
}

export default VTuberCard;
